import { render, staticRenderFns } from "./material.vue?vue&type=template&id=1dcb10f4&scoped=true"
import script from "./material.vue?vue&type=script&lang=js"
export * from "./material.vue?vue&type=script&lang=js"
import style0 from "./material.vue?vue&type=style&index=0&id=1dcb10f4&prod&lang=scss&scoped=true"
import style1 from "./material.vue?vue&type=style&index=1&id=1dcb10f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcb10f4",
  null
  
)

export default component.exports